import { jsx as o, jsxs as d } from "react/jsx-runtime";
import { c as n } from "../../index-Cu0xwYjD.js";
import { s } from "../../useIDSButtonGroupItem-B6pjgOX2.js";
import G, { useMemo as _ } from "react";
import { propagateTestid as u, toArray as g } from "../../utils/helpers.js";
import { useIdIfNeeded as x } from "../../utils/hooks/useIdIfNeeded.js";
import { IressButtonGroupProvider as B } from "./ButtonGroupProvider.js";
import { b as I } from "../../ToasterProvider-Bw9KrSYf.js";
import { GlobalCSSClass as S } from "../../utils/enums.js";
const q = ({
  children: c,
  className: f,
  "data-testid": t,
  defaultSelected: p,
  hiddenLabel: i,
  label: r,
  multiple: b,
  onChange: v,
  options: y,
  selected: N,
  ...a
}) => {
  const l = x({ id: a.id }), e = `${l}--label`, h = _(() => typeof r == "string" ? /* @__PURE__ */ o(
    "div",
    {
      id: e,
      className: n(s.label, {
        [S.SROnly]: i
      }),
      "data-testid": u(t, "label"),
      children: r
    }
  ) : G.cloneElement(r, {
    id: e
  }), [t, i, e, r]);
  return /* @__PURE__ */ o(
    B,
    {
      defaultSelected: p,
      multiple: b,
      onChange: v,
      selected: N,
      children: /* @__PURE__ */ d(
        "div",
        {
          className: n(f, s.buttonGroup),
          id: l,
          "data-testid": t,
          ...a,
          children: [
            h,
            /* @__PURE__ */ d("div", { role: "group", "aria-labelledby": e, className: s.values, children: [
              c,
              g(y).map((m) => /* @__PURE__ */ o(
                I,
                {
                  "data-testid": u(t, "button__button"),
                  children: m
                },
                m
              ))
            ] })
          ]
        }
      )
    }
  );
};
export {
  q as IressButtonGroup
};
